import { gql } from '@apollo/client';

export const FindManyFilesForUserQuery = gql`
  query FindManyFilesForUser($email: String!) {
    findManyFilesForUser(email: $email) {
      name
      type
      id
      createdAt
    }
  }
`;

export const FindManyGlobalFiles = gql`
  query FindManyGlobalFiles {
    findManyGlobalFiles {
      name
      id
    }
  }
`;

export const FindOneGlobalFile = gql`
  query FindOneGlobalFile($fileId: Int!) {
    findOneGlobalFile(fileId: $fileId) {
      name
      file
      id
    }
  }
`;

export const FindOneFileForUser = gql`
  query FindOneFileForUser($email: String!, $fileId: Int!) {
    findOneFileForUser(email: $email, fileId: $fileId) {
      name
      type
      file
      id
    }
  }
`;

export const ReviewEligibilityForProfile = gql`
  query ReviewEligibilityForProfile($profileId: Int!) {
    reviewEligibilityForProfile(profileId: $profileId) {
      documentsComplete
      contributionValidated
      depositValidated
      providedDocumentCount
      requiredDocumentCount
      providedOptionalDocumentCount
      optionalDocumentCount
    }
  }
`;

export const FindFilesAvailableForReuse = gql`
  query FindFilesAvailableForReuse($profileId: Int!) {
    findFilesAvailableForReuse(profileId: $profileId) {
      id
      name
      type
      createdAt
    }
  }
`;

export const DownloadAllFilesForUserAsZip = gql`
  query DownloadAllFilesForUserAsZip($email: String!) {
    downloadAllFilesForUserAsZip(email: $email) {
      fileName
      file
    }
  }
`;
